function init() {
	let modals = document.querySelector('.modals');

	if (modals) {
		let cross = modals.querySelectorAll('.cross');

		cross.forEach((item) => {
			item.addEventListener('click', () => {
				modals.classList.remove('d-block');
				item.parentNode.classList.remove('modals__active');
			});
		});

		let passwords = modals.querySelectorAll('label[data-atr="password"]');

		passwords.forEach((item) => {
			let watch = item.querySelector('.input__watch');

			watch.addEventListener('click', () => {
				let input = item.querySelector('input');
				if (input.getAttribute('type') === 'password') {
					input.setAttribute('type', 'text');
					watch.textContent = 'Скрыть пароль';
				} else {
					input.setAttribute('type', 'password');
					watch.textContent = 'Показать пароль';
				}
			});
		});

		let close = modals.querySelector('.modals__thankYou--button');
		let modalThankYou = modals.querySelector('.modals__thankYou');

		close.addEventListener('click', () => {
			modals.classList.remove('d-block');
			modalThankYou.classList.remove('modals__active');
		});

		let closeThankYou = modals.querySelector('.modals__thankYouReview--inner > .btn');
		let modalThankYouR = modals.querySelector('.modals__thankYouReview');

		closeThankYou.addEventListener('click', () => {
			modals.classList.remove('d-block');
			modalThankYouR.classList.remove('modals__active');
		});

		const tomatisBtns = document.querySelectorAll('.js-modals-tomatis-btn');
		const modalTomatis = document.querySelector('.modals-tomatis');

		tomatisBtns.forEach((item) => {
			item.addEventListener('click', () => {
				modals.classList.toggle('d-block');
				modalTomatis.classList.toggle('modals__active');
			});
		});
	}
}

export default {
	init,
};
